import { render, staticRenderFns } from "./LeftSidebarItemToggle.vue?vue&type=template&id=49462648&scoped=true"
import script from "./LeftSidebarItemToggle.vue?vue&type=script&lang=js"
export * from "./LeftSidebarItemToggle.vue?vue&type=script&lang=js"
import style0 from "./LeftSidebarItemToggle.vue?vue&type=style&index=0&id=49462648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49462648",
  null
  
)

export default component.exports